import { createSelector } from 'reselect';

import { getNamPersonalLoansCalculator } from './index';

export const getCalculator = createSelector(
    getNamPersonalLoansCalculator,
    (personalLoansCalculator) => personalLoansCalculator.calculator
);

export const getCalculationResults = createSelector(getCalculator, (calculator) => calculator.calculationResults);

export const getForm = createSelector(getCalculator, (calculator) => calculator.form);

const getFormField = (field) => createSelector(getForm, (form) => form[field]);

export const getAmountBorrowed = getFormField('amountBorrowed');
export const getCustomAmountBorrowed = getFormField('customAmountBorrowed');
export const getRepaymentDuration = getFormField('repaymentDuration');
export const getCustomRepaymentDuration = getFormField('customRepaymentDuration');
